module.exports = __webpack_public_path__ + "img/fulfillment.d57b8ab5.svg";